import { Loader2, Sparkles, AlertCircle } from 'lucide-react'

/* ═════════════════════════════════════════════════════════════════
   Status Configuration — unified across all modules.
   Цвета — CSS-переменные дизайн-системы (--color-warning/accent/info/success/danger).
   Так фон, бордер и текст одного статуса одинаковы во всём приложении и подхватывают
   light/dark тему автоматически. Не возвращать hex-коды — это была причина «зоопарка».
   ═════════════════════════════════════════════════════════════════ */
export const STATUS_CONFIG = {
  PENDING:    { color: 'var(--color-warning)', bg: 'var(--color-warning-bg)', label: 'В очереди',    icon: Loader2 },
  PROCESSING: { color: 'var(--color-accent)',  bg: 'var(--color-accent-bg)',  label: 'Генерация',    icon: Loader2 },
  COMPLETED:  { color: 'var(--color-info)',    bg: 'var(--color-info-bg)',    label: 'Готово',       icon: Sparkles },
  PUBLISHED:  { color: 'var(--color-success)', bg: 'var(--color-success-bg)', label: 'Опубликовано', icon: Sparkles },
  FAILED:     { color: 'var(--color-danger)',  bg: 'var(--color-danger-bg)',  label: 'Ошибка',       icon: AlertCircle },
}

/* ═════════════════════════════════════════════════════════════════
   LoadingIcon — reusable spinner with status colors
   Always uses Loader2 (arrows) for active states, colors vary by status.
   
   Props:
   - status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'PUBLISHED' | 'FAILED'
   - size: number (default: 16)
   - className: string (optional)
   - style: object (optional)
   ═════════════════════════════════════════════════════════════════ */
export default function LoadingIcon({ status = 'PROCESSING', size = 16, className = '', style = {} }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.PROCESSING
  const Icon = config.icon
  const isActive = status === 'PENDING' || status === 'PROCESSING'

  return (
    <Icon
      size={size}
      className={className}
      style={{
        color: config.color,
        flexShrink: 0,
        ...(isActive ? { animation: 'spin 1s linear infinite' } : {}),
        ...style,
      }}
    />
  )
}
